module.exports = {
    showdetailsid: "d505646c-d00a-4e3c-92a2-668828c70e07"
}


// WEBPACK FOOTER //
// ./src/utils/config.js